import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { MDXRemote } from "next-mdx-remote";

const TextLeft = ({ header, title1, title2, title3, content, image, cta }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Box marginBottom={-10}>
      <Grid container spacing={4} direction={isMd ? "row" : "column-reverse"}>
        <Grid item xs={12} md={6} data-aos={isMd ? "fade-right" : "fade-up"}>
          <Box marginTop={7}>
            {header && (
              <Typography
                component="h6"
                fontWeight={700}
                variant={"h6"}
                color="primary"
                gutterBottom
                textTransform="uppercase"
              >
                {header}
              </Typography>
            )}

            <Typography
              component="h2"
              fontWeight={700}
              variant={"h4"}
              gutterBottom
            >
              {title1}{" "}
              <Typography color="primary" variant="inherit" component="span">
                {title2}
              </Typography>{" "}
              {title3 && ` ${title3}`}
            </Typography>
          </Box>
          <Typography
            variant={"h6"}
            component="div"
            color="textSecondary"
            fontWeight={400}
          >
            {content?.frontmatter ? <MDXRemote {...content} /> : content}
          </Typography>

          {cta && (
            <Box sx={{ textAlign: { xs: "center", lg: "left" } }}>{cta}</Box>
          )}
        </Grid>

        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={isMd ? "fade-left" : "fade-up"}
        >
          <Box width={"100%"} textAlign={isMd ? "right" : "center"}>
            {image}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TextLeft;
